<template>
	<div class="currencyAdd">
		<div class="item" v-for="(item, index) in valueList" :key="item.currency">
			<el-input placeholder="请输入价格" v-model="item.price" class="input-with-select" @input="change">
				<el-select v-model="item.currency" slot="prepend" placeholder="请选择"  @input="change">
					<el-option
						v-for="optionItem in options"
						:key="optionItem.value"
						:label="optionItem.label"
						:value="optionItem.value"
						:disabled="optionItem.disabled"
					>
					</el-option>
				</el-select>
				<!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
				<span slot="append">{{ getSymbol(item.currency) }}</span>
			</el-input>

			<el-button
				type="danger"
				icon="el-icon-delete"
				size="small"
				circle
				v-if="index < valueList.length - 1"
				@click="remove(index)"
			></el-button>

			<el-button
				type="primary"
				icon="el-icon-plus"
				size="small"
				circle
				v-else
				@click="add"
			></el-button>
		</div>
	</div>
</template>

<script>
import { currencies } from '@/common/dictionary.js';

export default {
	name: 'currencyAdd',
	props: ['value'],
	data() {
		return {
			valueList: [],
		};
	},
	computed: {
		options(self) {
			let { valueList } = self;
			let map = valueList.map(item => item.currency);

			let options = currencies.map(item => {
				return {
					...item,
					disabled: map.includes(item.value),
				};
			});

			return options;
		},
	},
	watch: {
		value: {
			handler(val) {
				this.valueList = val;
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		// 返回对应的货币符号
		getSymbol(currency) {
			return currency ? currencies.find(item => item.value === currency).symbol : '-';
		},
		// 删除
		remove(index) {
			this.valueList.splice(index, 1);
      this.change()
		},
		// 添加
		add() {
			this.valueList.unshift({
				price: 0,
				currency: '',
			});
      this.change()
		},
		// 传给父组件
		change() {
			this.$emit('input', this.valueList);
		},
	},
};
</script>

<style lang="scss" scoped>
.currencyAdd {
	width: 85%;

	.item {
		display: flex;
		align-items: center;

		::v-deep .el-input {
			margin-right: 10px;

			.el-select .el-input {
				width: 120px;
			}

			.el-input-group__append {
				padding: 0 0;
				text-align: center;
				width: 35px;
				font-size: 17px;
				font-weight: 500;
			}
		}

		.el-button {
			width: 30px;
			height: 30px;
			padding: 8px;
		}
	}
}
</style>
